/**
 * A single-choice dropdown over plain `{ value, label }` options.
 *
 * `LookupSelect` in the tickets feature does the same over `TicketLookupItem`s
 * with translatable labels; the Migrate area's lists (the Ivanti taxonomy, the
 * catalog offerings) arrive as plain strings, so this is the same `Select`
 * tree without the translation layer.
 */

import { Select } from "@norican/react";

export interface OptionSelectProps {
  options: readonly { value: string; label: string }[];
  value: string | null;
  onValueChange: (value: string) => void;
  placeholder: string;
  disabled?: boolean;
  "aria-label"?: string;
}

export function OptionSelect({
  options,
  value,
  onValueChange,
  placeholder,
  disabled = false,
  "aria-label": ariaLabel,
}: OptionSelectProps) {
  return (
    <Select.Root
      value={value}
      items={[...options]}
      disabled={disabled || options.length === 0}
      onValueChange={(next) => onValueChange(String(next))}
    >
      <Select.Trigger placeholder={placeholder} aria-label={ariaLabel} />
      <Select.Portal>
        <Select.Positioner sideOffset={4}>
          <Select.Popup width="anchor">
            <Select.List>
              {options.map((option) => (
                <Select.Item key={option.value} value={option.value}>
                  {option.label}
                </Select.Item>
              ))}
            </Select.List>
          </Select.Popup>
        </Select.Positioner>
      </Select.Portal>
    </Select.Root>
  );
}
